import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { CreditTabs } from "./CreditTabs";
import { InputLabel } from "@material-ui/core";
import styled, { css } from "styled-components";
import { DepositStatus } from "model/TipCredit";
import { WithdrawalsTab } from "./withdrawalsTab";
import { useTips } from "stores/tipsStore/tipsStore";
import { H3 } from "components/Typography/text.styled";
import { Dialog, TextField, Grid } from "@mui/material";
import { ButtonStyled } from "components/buttons/buttons.styled";
import { CustomIcon } from "components/icon/customIcon.component";
import { getStatusIcon, getStatusStyle } from "utils/creditStatus";
import {
  Table,
  Paper,
  TableRow,
  TableBody,
  TableCell,
  TableHead,
  TableContainer,
} from "@mui/material";

type Props = {
  companyId: number | undefined;
};

export const TipsModal: React.FC<Props> = (props) => {
  const {
    deposits,
    tipAmount,
    modalOpen,
    withdrawals,
    closeModal,
    setDeposits,
    setTipAmount,
    fetchDeposits,
    submitTipDeposit,
    fetchWithdrawals,
    updateDepositStatus,
  } = useTips();

  const [selectedTab, setSelectedTab] = useState<"deposits" | "withdrawals">(
    "deposits"
  );

  useEffect(() => {
    if (modalOpen && props.companyId) {
      fetchDeposits(props.companyId);
      fetchWithdrawals(props.companyId);
    }
  }, [modalOpen, props.companyId]);

  return (
    <Dialog maxWidth="xl" open={modalOpen} onClose={closeModal}>
      <ModalContainer>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <H3>Manage Tip Credit</H3>
          <CustomIcon
            name="cross"
            size="30px"
            onClick={closeModal}
            style={{ margin: "10px 0 0 0" }}
            title="Close"
          />
        </div>
        <Grid container>
          <Grid>
            <InputLabel>Add credit deposit</InputLabel>
            <TextField
              value={tipAmount}
              label="Tip Amount"
              variant="outlined"
              style={{ width: "100%", display: "flex", marginTop: "10px" }}
              onChange={(e) => {
                const value = e.target.value;
                const number = value === "" ? "" : Number(value);
                if (number === "" || (number >= 0 && number <= 99999)) {
                  setTipAmount(number);
                }
              }}
            />
            <ButtonStyled
              style={{ width: "100%", marginTop: "10px", marginBottom: "10px" }}
              onClick={() => submitTipDeposit(props.companyId)}
            >
              Deposit Tip Credit
            </ButtonStyled>
          </Grid>
        </Grid>

        <CreditTabs
          selectedTab={selectedTab}
          onSelectTab={setSelectedTab}
          depositCount={deposits.length}
          withdrawalsCount={withdrawals.length}
        />
        <TableContainer component={Paper} sx={{ mt: 2 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <strong>ID</strong>
                </TableCell>
                <TableCell>
                  <strong>Amount</strong>
                </TableCell>
                <TableCell>
                  <strong>Reference</strong>
                </TableCell>
                <TableCell>
                  <strong>Date</strong>
                </TableCell>
                <TableCell>
                  <strong>Status</strong>
                </TableCell>
                <TableCell>
                  <strong>Actions</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {selectedTab === "deposits" && (
                <>
                  {" "}
                  {deposits.map((deposit, index) => (
                    <TableRow key={index}>
                      <TableCell>{deposit.id}</TableCell>
                      <TableCell>{deposit.amount} kr</TableCell>
                      <TableCell>{deposit.reference}</TableCell>
                      <TableCell>
                        {new Date(deposit.createdAt!).toLocaleString("sv-SE", {
                          dateStyle: "short",
                          timeStyle: "short",
                        })}
                      </TableCell>
                      <TableCell>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          {getStatusIcon(deposit.status)}
                          <span style={getStatusStyle(deposit.status)}>
                            {deposit.status}
                          </span>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: "flex", gap: 1 }}>
                          <ButtonStyled
                            onClick={() =>
                              updateDepositStatus(
                                deposit.id,
                                deposit.companyId,
                                DepositStatus.Approved
                              )
                            }
                          >
                            Approve
                          </ButtonStyled>
                          <ButtonStyled
                            onClick={() =>
                              updateDepositStatus(
                                deposit.id,
                                deposit.companyId,
                                DepositStatus.Failed
                              )
                            }
                          >
                            Fail
                          </ButtonStyled>
                          <ButtonStyled
                            onClick={() =>
                              updateDepositStatus(
                                deposit.id,
                                deposit.companyId,
                                DepositStatus.Cancelled
                              )
                            }
                          >
                            Cancel
                          </ButtonStyled>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </>
              )}

              {selectedTab === "withdrawals" && (
                <WithdrawalsTab companyId={props.companyId} />
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </ModalContainer>
    </Dialog>
  );
};

const ModalContainer = styled.div`
  padding: 0px 20px 30px 20px;
`;
